import { Navigate, RouteObject } from "react-router-dom";
import AuthenticatedLayout from "../components/layouts/AuthenticatedLayout/AuthenticatedLayout";
import BaseLayout from "../components/layouts/BaseLayout/BaseLayout";
import UnverifiedLayout from "../components/layouts/UnverifiedLayout/UnverifiedLayout";
import Dashboard from "../pages/dashboard/Dashboard";
import Home from "../pages/home/Home";
import InfoRejected from "../pages/info-rejected/InfoRejected";
import InfoRequested from "../pages/info-requested/InfoRequested";
import ManageStaff from "../pages/manage-staff/ManageStaff";
import MutateStaff from "../pages/manage-staff/mutate-staff/MutateStaff";
import MyClaims from "../pages/my-claims/MyClaims";
import ClaimDetails from "../pages/my-claims/claim-details/ClaimDetails";
import MyCovers from "../pages/my-cover/MyCovers";
import MyProfile from "../pages/my-profile/MyProfile";
import ChangeWalletAddress from "../pages/my-profile/change-wallet-address/ChangeWalletAddress";
import PurchaseCover from "../pages/purchase-cover/PurchaseCover";
import Cart from "../pages/purchase-cover/cart/Cart";
import RaiseNewClaim from "../pages/raise-new-claim/RaiseNewClaim";
import RegistrationRequest from "../pages/registration-request/RegistrationRequest";
import ValidateSumsub from "../pages/validate-sumsub/ValidateSumsub";
import PurchaseTraditionalInsurance from "../pages/purchase-traditional-insurance/PurchaseTraditionalInsurance";
import TraditionalCoverDetails from "../pages/my-cover/cover-details/TraditionalCoverDetails";
import AssetCoverDetails from "../pages/my-cover/cover-details/AssetCoverDetails";

export const routeMapper: RouteObject[] = [
  {
    path: "/",
    element: <BaseLayout />,
    children: [
      {
        path: "",
        element: <Home />,
      },
      {
        path: "registration",
        element: <RegistrationRequest />,
      },
      {
        path: "validate",
        element: <UnverifiedLayout />,
        children: [
          {
            path: "sumsub",
            element: <ValidateSumsub />,
          },
          {
            path: "kyc-info",
            element: <InfoRequested />,
          },
          {
            path: "kyc-rejected",
            element: <InfoRejected />,
          },
        ],
      },
      {
        path: "",
        element: <AuthenticatedLayout />,
        children: [
          {
            path: "dashboard",
            element: <Dashboard />,
          },
          {
            path: "purchase-cover",
            element: <PurchaseCover />,
          },
          {
            path: "purchase-traditional-insurance",
            element: <PurchaseTraditionalInsurance />,
          },
          {
            path: "my-covers",
            children: [
              {
                path: "",
                element: <MyCovers />,
              },
              {
                path: ":coverId/traditional-cover",
                element: <TraditionalCoverDetails />,
              },
              {
                path: ":coverId/asset-cover",
                element: <AssetCoverDetails />,
              },
              {
                path: "raise-new-claim/:coverId",
                element: <RaiseNewClaim />,
              },
            ],
          },
          {
            path: "my-claims",
            children: [
              {
                path: "",
                element: <MyClaims />,
              },
              {
                path: ":claimId",
                element: <ClaimDetails />,
              },
            ],
          },
          {
            path: "cart",
            element: <Cart />,
          },
          {
            path: "my-profile",
            children: [
              {
                path: "",
                element: <MyProfile />,
              },
              {
                path: "change-wallet-address",
                element: <ChangeWalletAddress />,
              },
              {
                path: "edit/:userId",
                element: <MutateStaff isEdit={true} isProfile={true} />,
              },
            ],
          },
          {
            path: "manage-staff",
            children: [
              {
                path: "",
                element: <ManageStaff />,
              },
              {
                path: "add",
                element: <MutateStaff />,
              },
              {
                path: "edit/:userId",
                element: <MutateStaff isEdit={true} />,
              },
            ],
          },
        ],
      },
      {
        path: "*",
        element: <Navigate to="/" />,
      },
    ],
  },
];
